// userService.js
import { get, post, patch } from './common';



export const getSupportSessions = (filterData, headers ) => {
    return get('support/get-support-sessions', filterData, headers);
};


export const getInboxList  = filterData => {
    console.log("filterData", filterData)
    return get('support/get-inbox-list', filterData);
};


export const acceptChatRequest  = (conversationId) => {
    return post('support/accept-chat-request/'+conversationId);
};


export const acceptCallRequest  = (conversationId) => {
    return post('support/accept-call-request/'+conversationId);
};

export const rescheduleCallRequest  = (conversationId, data) => {
    return post('support/reschedule-call/'+conversationId, data);
};

export const createInternalCallRequest = (data) => {
    return post('support/create-internal-call-request/', data);
  };
  
export const createSupportCallRequest = (data) => {
    return post('support/create-support-call-request/', data);
};


export const createSupportChatRequest = (data) => {
    return post('support/create-support-chat-request/', data);
};

export const createInternalChatRequest = (data) => {
    return post('chat/create-internal-chat/', data);
};

export const endConversationRequest = (conversationId, data) => {
    return patch('support/end-support-chat/'+conversationId, data);
};
  